import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap-v5';
import Swal from 'sweetalert2';
import * as Yup from 'yup';
import { IEmpresaRegimeTributario } from '../../interfaces/IEmpresaRegimeTributario';
import { IEmpresas } from "../../interfaces/IEmpresas";
import EmpresaRegimeTributarioService from '../../services/EmpresaRegimeTributarioService';
import EmpresasService from '../../services/EmpresasService';
import EmpresasNovoModal from './EmpresasNovoModal';
import RegimeNovoModal from './RegimeNovoModal';
import AnexosModal from './AnexosModal';
import ConciliacaoConfigModal from './ConciliacaoConfigModal';
import PlanoContasModal from './PlanoContasModal';

/*Tradução */
import './../../../i18n/config';
import { useTranslation } from 'react-i18next';

export default function EmpresasModal({ toggleModal, show, empresa, title }: { toggleModal: (carregarEmpresas?: boolean) => void, show: boolean, empresa: IEmpresas | null, title: string }) {

    const [abaSelecionada, setAbaSelecionada] = useState<string>('1');
    const [atualizarLista, setAtualizarLista] = useState<boolean>(false);
    const [empresaVM, setEmpresaVM] = useState<IEmpresas | null>(null);
    const { t } = useTranslation();

    useEffect(() => {
        setEmpresaVM(empresa);
        formikRegimeTributario.setFieldValue('empresaID', empresa ? empresa.id : 0);

        // eslint-disable-next-line
    }, [empresa]);

    const empresasSchema = Yup.object().shape({
        cnpj: Yup.string(),
        dataAberturaString: Yup.string(),
        bairro: Yup.string(),
        municipio: Yup.string(),
        estado: Yup.string(),
        razaoSocial: Yup.string(),
        email: Yup.string(),
        nomeFantasia: Yup.string(),
        porte: Yup.string(),
        telefone: Yup.string(),
        telefoneAdicional: Yup.string(),
        situacaoCadastral: Yup.string(),
        dataSituacaoCadastralString: Yup.string(),
        motivoSituacaoCadastral: Yup.string(),
        situacaoEspecial: Yup.string(),
        dataSituacaoEspecialString: Yup.string(),
        atividadePrincipal: Yup.string(),
        atividadeSecundaria: Yup.string(),
        endereco: Yup.string(),
        numero: Yup.string(),
        complemento: Yup.string(),
        cep: Yup.string(),
        tipoSistema: Yup.string(),
        umaContaPorFornecedor: Yup.bool(),
        agruparContas: Yup.bool()
    });

    const formInitialValues: IEmpresas = {
        id: 0,
        atividadePrincipal: "",
        importacaoEspecial: false,
        atividadeSecundaria: "",
        agruparContas: false,
        bairro: "",
        cep: "",
        cnpj: "",
        complemento: "",
        dataAberturaString: '',
        dataSituacaoCadastralString: '',
        dataSituacaoEspecialString: '',
        email: "",
        endereco: "",
        estado: "",
        esteiraImportando: 0,
        motivoSituacaoCadastral: "",
        municipio: "",
        nomeFantasia: "",
        numero: "",
        porte: "",
        razaoSocial: "",
        tipoSistema: "",
        empresaRegimesTributarios: [],
        situacaoCadastral: "",
        situacaoEspecial: "",
        telefone: "",
        telefoneAdicional: "",
        clienteID: 0,
        umaContaPorFornecedor: false
    }

    const formikEmpresa = useFormik({
        initialValues: formInitialValues,
        validationSchema: empresasSchema,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                let dataAberturaSplit = values.dataAberturaString?.split('/');
                let dataSituacaoCadastralSplit = values.dataSituacaoCadastralString?.split('/');
                let dataSituacaoEspecialSplit = values.dataSituacaoEspecialString?.split('/');


                if (dataAberturaSplit)
                    values.dataAbertura = new Date(`${dataAberturaSplit[2]}-${dataAberturaSplit[1]}-${dataAberturaSplit[0]}`);

                if (dataSituacaoCadastralSplit)
                    values.dataSituacaoCadastral = new Date(`${dataSituacaoCadastralSplit[2]}-${dataSituacaoCadastralSplit[1]}-${dataSituacaoCadastralSplit[0]}`);

                if (dataSituacaoEspecialSplit)
                    values.dataSituacaoEspecial = new Date(`${dataSituacaoEspecialSplit[2]}-${dataSituacaoEspecialSplit[1]}-${dataSituacaoEspecialSplit[0]}`);

                if (values.id === 0) {
                    await EmpresasService.criar(values)
                } else {
                    await EmpresasService.atualizar({ ...values, id: empresa?.id || 0 })
                }

                setSubmitting(false);

                await Swal.fire({
                    text: !values.id ? t('Empresa foi adicionada com sucesso') : t('Empresa foi editada com sucesso'),
                    timer: 4000,
                    icon: 'success',
                    showConfirmButton: false
                });

                toggleModal(true);
            } catch (error) {
                setSubmitting(false)
                Swal.fire({
                    text: t('Não foi possivel salvar a Empresa'),
                    timer: 4000,
                    icon: 'error',
                    showConfirmButton: false
                });
            }
        },
    });

    const regimeTributarioSchema = Yup.object().shape({
        anoOpcao: Yup.string().min(4, 'Mínimo 4 caracteres').max(4, 'Maximo 4 caracteres').required('Descrição é obrigatório'),
        regimeTributarioID: Yup.string().required('Descrição é obrigatório'),
    })

    const formikRegimeTributario = useFormik({
        initialValues: { anoOpcao: new Date().getFullYear(), regimeTributarioID: '', empresaID: empresa ? empresa.id : 0, id: 0 } as IEmpresaRegimeTributario,
        validationSchema: regimeTributarioSchema,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                values.data = new Date();

                if (values.id === 0) {
                    var result = await EmpresaRegimeTributarioService.criar(values);
                    if (empresaVM !== null) {
                        var regimes = empresaVM.empresaRegimesTributarios ?? [];
                        regimes.push(result);
                        setEmpresaVM({ ...empresaVM, empresaRegimesTributarios: regimes });
                    }
                }

                setAtualizarLista(true);
                formikRegimeTributario.resetForm();

                await Swal.fire({
                    text: values.id === 0 ? t('Regime foi adicionada com sucesso') : t('Regime foi editado com sucesso'),
                    timer: 4000,
                    icon: 'success',
                    showConfirmButton: false
                });
            } catch (error) {
                setSubmitting(false)
                Swal.fire({
                    text: t('Não foi possivel salvar a Regime'),
                    timer: 4000,
                    icon: 'error',
                    showConfirmButton: false
                });
            }

            setSubmitting(false);
        },
    });

    const BotoesHeaderTabela = () => {
        const opcoesFiltros = [
            { id: '1', descricao: t('Cadastro Empresa') },
            { id: '2', descricao: t('Regime Tributário') },
            { id: '3', descricao: t('Anexos') },
            { id: '4', descricao: t('Conciliação') },
            { id: '5', descricao: t('Plano de Contas') }
        ];

        return <>
            {
                opcoesFiltros.map((x, index) => <button key={index} disabled={x.id !== '1' && empresa === null} type="submit" id={x.id} className={`btn btn-filtro ${x.id === abaSelecionada && 'ativo'}`} onClick={() => setAbaSelecionada(x.id)}>{x.descricao}</button>)
            }
        </>
    };

    return <Modal size='xl' centered={true} show={show} onHide={() => {
        setAbaSelecionada('1');
        toggleModal(atualizarLista);
    }
    }>
        <div className="modal-content">
            <div className="modal-header" style={{ padding: '10px 15px 5px 35px' }}>
                <h5 className="modal-title titulo-modal">{title}</h5>
                <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                    <i onClick={() => {
                        setAbaSelecionada('1')
                        toggleModal(atualizarLista);
                    }} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                </div>
            </div>
            <div className="modal-body" style={{ padding: '10px' }}>
                <BotoesHeaderTabela />
                <EmpresasNovoModal formikEmpresa={formikEmpresa} empresa={empresa} abaSelecionada={abaSelecionada} />

                {
                    empresaVM !== null && (
                        <>
                            <RegimeNovoModal setEmpresa={setEmpresaVM} empresa={empresaVM} formikRegimeTributario={formikRegimeTributario} abaSelecionada={abaSelecionada} />
                            <AnexosModal empresa={empresaVM} abaSelecionada={abaSelecionada} />
                            <ConciliacaoConfigModal empresa={empresaVM} abaSelecionada={abaSelecionada} />
                            <PlanoContasModal empresa={empresaVM} abaSelecionada={abaSelecionada} />
                        </>
                    )
                }
            </div>
        </div>
        <div className="modal-footer" style={{ paddingTop: '10px', justifyContent: 'center' }}>
            <button disabled={formikEmpresa.isSubmitting} onClick={() => {
                setAbaSelecionada('1')
                toggleModal(atualizarLista);
            }} type="button" className="btn btn-modal-cancelar me-5"> {t("CANCELAR")} </button>
            <button disabled={formikEmpresa.isSubmitting || !formikEmpresa.isValid} onClick={() => formikEmpresa.submitForm()} type="button" className="btn btn-primario ms-5">
                {!formikEmpresa.isSubmitting && t('SALVAR')}
                {formikEmpresa.isSubmitting && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                        {t("Salvando...")}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                )}
            </button>
        </div>
    </Modal>
}
